
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Typing for Google Analytics global object
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// GA4 Measurement ID
const GA_MEASUREMENT_ID = 'G-9HR9YQ3MLC';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip in development environment
    if (process.env.NODE_ENV === 'development') {
      return;
    }
    
    // Initialize Google Analytics
    if (!window.dataLayer) {
      window.dataLayer = [];
      window.gtag = function() {
        window.dataLayer.push(arguments);
      };
      
      window.gtag('js', new Date());
      window.gtag('config', GA_MEASUREMENT_ID, {
        send_page_view: false // We'll handle this manually for SPA
      });
    }
  }, []);

  // Track page views when route changes
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname + location.search
      });
      
      console.log(`[Analytics] Page view tracked: ${location.pathname}`);
    }
  }, [location]);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;
